import React, { useContext, useEffect, useState } from 'react'
import { apiGet } from '../../../utils/apiFetch'
import apiPath from '../../../utils/pathObj'
import Pagination from '../../Pagination'
import AuthContext from 'context/AuthContext'
import dayjs from 'dayjs'
import ODateRangePicker from 'components/shared/datePicker/ODateRangePicker'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import helpers from 'utils/helpers'
import OnboardingList from './OnboardingList'
import AddOnboarding from './AddOnboarding'

function Onboarding () {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { logoutUser, user, updatePageName } = useContext(AuthContext)
  const [paginationObj, setPaginationObj] = useState({
    page: 1,
    pageCount: 1,
    pageRangeDisplayed: 10
  })
  const [forms, setForms] = useState([])
  const [page, setPage] = useState(1)
  const [pageSize] = useState(10)
  const [item, setItem] = useState('')
  const [addOnboarding, setAddOnboarding] = useState(false)

  const [sort, setSort] = useState({
    sortType: 'desc',
    sortBy: 'createdAt'
  })
  const [filterData, setFilterData] = useState({
    category: '',
    searchkKey: '',
    startDate: '',
    endDate: '',
    isReset: false,
    isFilter: false
  })

  const handlePageUpdateData = data => {
    if (
      (data?.deletePage && forms?.length >= 1) ||
      (filterData.isFilter &&
        filterData.category &&
        data?.statusChange &&
        forms?.length >= 1)
    ) {
      if (forms?.length >= 1) {
        setPage(page - 1)
        setPaginationObj({ ...paginationObj, page: page - 1 })
      }
    }
  }

  const setFormData = (response, resultStatus) => {
    setForms(response?.docs)
    setPaginationObj({
      ...paginationObj,
      page: resultStatus ? response?.page : null,
      pageCount: resultStatus ? response?.totalPages : null,
      perPageItem: resultStatus ? response?.docs?.length : null,
      totalItems: resultStatus ? response?.totalDocs : null
    })
  }

  const getForms = async data => {
    try {
      const { category, startDate, endDate, searchkKey } = filterData

      handlePageUpdateData(data)

      const payload = {
        page,
        pageSize,
        status: category,
        startDate: startDate ? dayjs(startDate).format('YYYY-MM-DD') : null,
        endDate: endDate ? dayjs(endDate).format('YYYY-MM-DD') : null,
        keyword: searchkKey,
        sortBy: sort.sortBy,
        sortType: sort.sortType,
        categoryType: 'onboarding',
        createdBy: user?.companyID || ''
      }

      const path = apiPath.getForms
      const result = await apiGet(path, payload)

      if (result?.status === 200) {
        const response = result?.data?.results
        const resultStatus = result?.data?.success
        setFormData(response, resultStatus)
      }
    } catch (error) {
      console.log('error ', error)
      setPaginationObj({})
      if (error.response.status === 401 || error.response.status === 409) {
        logoutUser()
      }
    }
  }

  
  const handlePageClick = event => {
    const newPage = event.selected + 1
    setPage(newPage)
  }
  const handleFormsView = (formId) => {
    navigate("/forms-manager/view", { state: { id: formId } });
  };

  useEffect(() => {
    getForms()
  }, [page, filterData, sort])

  const handleSearchKey = e => {
    setFilterData({ ...filterData, searchkKey: e.target.value, isFilter: true })
    setPage(1)
  }

  const handleReset = () => {
    setFilterData({
      category: '',
      searchkKey: '',
      startDate: '',
      endDate: '',
      isReset: true,
      isFilter: false
    })
    setPage(1)
  }

  const handleDateChange = (start, end) => {
    setPage(1)
    setFilterData({
      ...filterData,
      startDate: start,
      endDate: end,
      isFilter: true
    })
  }

  useEffect(() => {
    updatePageName(t('FORMS_MANAGER'))
  }, [])

  const handleOnboarding = () => {
    setAddOnboarding(!addOnboarding);
  };
  
  const closeModal = () => {
    setAddOnboarding(false);
  };

  const handleAddOnboarding = () => {
    navigate('/forms-manager/addonboarding');
  };

  return (
    <div>
      <div className='bg-[#F9F9F9]'>
        <div className='px-3 py-4'>
          <div className='bg-white border border-[#E9EDF9] rounded-lg'>
            <form className='border-b border-b-[#E3E3E3] grid 2xl:grid-cols-3 xl:grid-cols-2 lg:grid lg:grid-cols-1 gap-2 px-4 py-3'>
              <div className='col-span-3 flex flex-wrap  items-center'>
                <div className='flex items-center lg:pt-0 pt-3 flex-wrap mb-2'>
                  <div className='relative flex items-center mb-3'>
                    <div className='absolute inset-y-0 right-0 flex items-center pl-3 mr-3 pointer-events-none'>
                      {!filterData?.searchkKey && (
                        <svg
                          aria-hidden='true'
                          className='w-4 h-4 text-[#A5A5A5] dark:text-gray-40'
                          fill='none'
                          stroke='currentColor'
                          viewBox='0 0 24 24'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <path
                            strokeLinecap='round'
                            strokeLinejoin='round'
                            strokeWidth='2'
                            d='M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z'
                          />
                        </svg>
                      )}
                    </div>
                    <input
                      type='search'
                      id='default-search'
                      className='block w-full p-2 outline-none text-sm text-gray-900 2xl:min-w-[250px] xl:min-w-[300px] rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'
                      placeholder={t('SEARCH_BY_TITLE')}
                      value={filterData?.searchkKey}
                      title=''
                      required
                      onChange={e => handleSearchKey(e)}
                    />
                  </div>
                  <ODateRangePicker
                    handleDateChange={handleDateChange}
                    isReset={filterData?.isReset}
                    setIsReset={setFilterData}
                  />
                  <button
                    type='button'
                    onClick={handleReset}
                    className='bg-LightBlue text-sm px-8 ml-3 mb-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-DarkBlue sm:w-auto w-1/2'
                  >
                    {t('O_RESET')}
                  </button>
                  <button
                  onClick={handleAddOnboarding}
                  className='rounded-lg items-center border bg-LightBlue text-sm px-8 ml-3 mb-3 py-2 border-transparent text-white hover:bg-DarkBlue sm:w-auto w-1/2'
                  type='button'>
                  {t('O_ADD')}
                </button>
                </div>
              </div>
            </form>
            <OnboardingList
              forms={forms}
              user={user}
              getForms={getForms}
              handleFormsView={handleFormsView}
              page={page}
              setSort={setSort}
              sort={sort}
              item={item}
            />
            {paginationObj?.totalItems ? (
              <Pagination
                handlePageClick={handlePageClick}
                options={paginationObj}
                page={page}
              />
            ) : null}
          </div>
        </div>
      </div>
    </div>
  )
}
export default Onboarding
